import { useEffect } from 'react';
import { trackSessionHealth } from '@/instrument';

type SessionStatus = 'healthy' | 'crashed' | 'abnormal';

export const useSessionHealth = () => {
  // Track session as healthy when component mounts successfully
  useEffect(() => {
    trackSessionHealth('healthy');
  }, []);

  // Function to manually track session health
  const trackHealth = (status: SessionStatus) => {
    trackSessionHealth(status);
  };

  // Track healthy navigation/interaction
  const trackHealthyInteraction = () => {
    trackSessionHealth('healthy');
  };

  // Track abnormal session (e.g., unexpected behavior but not crashed)
  const trackAbnormalSession = () => {
    trackSessionHealth('abnormal');
  };

  return {
    trackHealth,
    trackHealthyInteraction,
    trackAbnormalSession,
  };
};
